<template>
    <Transition name="takeover">
        <div v-if="show" class="takeover fixed top-0 left-0 z-900 flex h-screen w-screen items-center justify-center">
            <div class="relative z-10 max-h-[calc(100vh-72px)] max-w-[calc(100vw-72px)] cursor-pointer">
                <a href="/restaurants" class="max-h-[calc(100vh-72px)] overflow-y-scroll">
                    <img :src="imageDesktop.url" :alt="imageDesktop.alt" class="hidden w-full max-w-367.5 lg:block" />
                    <img :src="imageMobile.url" :alt="imageMobile.alt" class="w-full max-w-3xl lg:hidden" />
                </a>
                <button
                    type="button"
                    class="border-primary hover:bg-primary hover:text-gold-lighter bg-gold-lighter absolute top-0 right-0 flex size-8 translate-x-1/3 -translate-y-1/3 cursor-pointer items-center justify-center rounded-full border-2 text-4xl leading-none transition-colors md:size-10 md:border-3 md:text-6xl"
                    @click.prevent="show = false"
                >
                    <span class="-mt-0.5 md:-mt-1">&times;</span>
                </button>
            </div>

            <div class="bg-gold-light/80 absolute top-0 left-0 size-full" @click.prevent="show = false"></div>
        </div>
    </Transition>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';

defineProps({
    imageDesktop: { type: Object, required: true },
    imageMobile: { type: Object, default: null },
});

const show = ref(true);

watch(show, toggle);

onMounted(() => toggle(show.value));

/**
 * Handle toggling of the takeover visibility state.
 *
 * @param {boolean} isShowing Whether the takeover is visible.
 */
function toggle(isShowing) {
    if (isShowing) {
        open();
    } else {
        close();
    }
}

/**
 * Handle opening of the takeover.
 */
function open() {
    document.addEventListener('keydown', bindEscape);
    document.querySelector('body').classList.add('overflow-hidden');
}

/**
 * Handle closing of the takeover.
 */
function close() {
    document.removeEventListener('keydown', bindEscape);
    document.querySelector('body').classList.remove('overflow-hidden');
}

/**
 * Bind the escape key to close the takeover.
 *
 * @param {KeyboardEvent} e The keydown event.
 */
function bindEscape(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
        show.value = false;
    }
}
</script>

<style>
.takeover-leave-active {
    transition:
        opacity 0.25s linear,
        transform 0.25s linear;
}

.takeover-leave-to {
    opacity: 0;
    transform: translateY(-100%);
}
</style>
